export const invokeProposeAllocationsForResourceRequest = bulkProposeAllocationsForResourceRequest => ({
  proposedAllocationInput
}) =>
  bulkProposeAllocationsForResourceRequest({
    variables: {
      input: {
        proposedAllocationInput
      }
    },
    refetchQueries: ['resourceRequestWithTimeoff']
  });
